import api from './api'

export interface UsersAvatarProps {
  avatar: File;
}

export const usersAvatar = async (props: UsersAvatarProps) => {
  const formdata = new FormData();
  formdata.append("avatar", props.avatar, `${props.avatar.name}`);
  const res = await api.post<unknown>('/users/avatar', formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  })
  return res
}
